<tgrid-layer-header [layer]="this" [additionIcons]="iconConfig()">

  <div class="legend">
    <div class="legend-label">
      <div class="color-circle" [style.background-color]="'#96B6F3'"></div>
      <span>Resiliency Curve Available</span>
    </div>
    <div class="legend-label">
      <div class="color-circle" [style.background-color]="'#444444'"></div>
      <span>No Resiliency Curve Available</span>
    </div>

  </div>

</tgrid-layer-header>
